import { createContext, useContext } from 'react'

/**
 * Context for the medical-certificate launcher. Kept in its own module so lightweight callers
 * (e.g. the booked-slot menu) can consume the hook without pulling in the full modal/editor tree,
 * and to satisfy react-refresh's component-only-export rule.
 *
 * Value shape: { openCreate(patientContext?), openView(patientContext?), close() } | null
 */
export const MedicalCertificateContext = createContext(null)

/** Returns the launcher API, or null when no provider is mounted (feature-detect to hide entry points). */
export function useMedicalCertificate() {
  return useContext(MedicalCertificateContext)
}
